import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker, createStaticRanges } from "react-date-range";
import dayjs from "dayjs";


import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import ToastMessage from "../../utils/muitoast";

const CalendarDropdown =({ open, setOpen, selectedDateRange, setSelectedDateRange, availableDates })=> {
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("warning");
  const calendarRef = useRef();

  const handleCloseToast = () => setToastOpen(false);

  const handleSelect = (ranges) => {
    const { startDate, endDate } = ranges.selection;
    const dayDiff = dayjs(endDate).diff(dayjs(startDate), "day") + 1;

    // if (dayDiff < 1 || dayDiff > 7) {
    //   setToastMessage("Please select a week date range only");
    //   setToastSeverity("warning");
    //   setToastOpen(true);
    //   return;
    // }

    setSelectedDateRange({ startDate, endDate, key: "selection" });
  };
  const staticRanges = createStaticRanges([
  {
    label: "This Week",
    range: () => ({
      startDate: dayjs().startOf("week").toDate(),
      endDate: dayjs().endOf("week").toDate()
    })
  },
  {
    label: "Last Week",
    range: () => ({
      startDate: dayjs().subtract(1, "week").startOf("week").toDate(),
      endDate: dayjs().subtract(1, "week").endOf("week").toDate()
    })
  },
  {
    label: "This Month",
    range: () => ({
      startDate: dayjs().startOf("month").toDate(),
      endDate: dayjs().endOf("month").toDate()
    })
  },
  {
    label: "Last Month",
    range: () => ({
      startDate: dayjs().subtract(1, "month").startOf("month").toDate(),
      endDate: dayjs().subtract(1, "month").endOf("month").toDate()
    })
  }
]);
  const availableSet = new Set(availableDates);
  // Close dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setOpen]);

  if (!open) return null;

  return (
    <div
      ref={calendarRef}
      className="absolute z-50 mt-4 shadow-lg rounded bg-white p-2"
    >
      {/* <DateRange
        onChange={handleSelect}
        moveRangeOnFirstSelection={false}
        ranges={[selectedDateRange]}
        months={1}
        direction="horizontal"
        showSelectionPreview={true}
          staticRanges={staticRanges}

      /> */}
<DateRangePicker
  onChange={handleSelect}
  ranges={[selectedDateRange]}
  staticRanges={staticRanges}
  inputRanges={[]}
  moveRangeOnFirstSelection={false}
  months={1}
  direction="vertical"
/>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={toastOpen}
        handleClose={handleCloseToast}
      />
    </div>
  );
};

export default CalendarDropdown;
